import React, { useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Tabs from '@components/Tabs/Tabs';

import DEIPageDonutCharts from '../DEIPageDonutCharts/DEIPageDonutCharts';

import {
  DEIPageTeamsSectionSECTION,
} from './DEIPageTeamsSection.styles';

const DEIPageTeamsSection = ({ teams }) => {
  const [activeTeam, setActiveTeam] = useState(0);

  return (
    <DEIPageTeamsSectionSECTION>
      <div className="container">
        <h2>Our teams by the numbers</h2>
        <Tabs
          activeOption={activeTeam}
          onClickOption={value => setActiveTeam(value)}
          options={teams.map(({ title }, i) => ({
            title,
            value: i,
          }))}
        />
        <DEIPageDonutCharts data={teams[activeTeam]} />
      </div>
    </DEIPageTeamsSectionSECTION>
  );
}

export default DEIPageTeamsSection;
